var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D16",
    d: "M16 20a5.333 5.333 0 005.333-5.333V8a5.333 5.333 0 10-10.666 0v6.667A5.333 5.333 0 0016 20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D16",
    d: "M25.333 14.667a1.333 1.333 0 00-2.666 0 6.667 6.667 0 11-13.334 0 1.333 1.333 0 00-2.666 0 9.333 9.333 0 008 9.226v2.774h-2.814c-.655 0-1.186.53-1.186 1.186v.294c0 .655.531 1.186 1.186 1.186h8.294c.655 0 1.186-.531 1.186-1.186v-.294c0-.655-.53-1.186-1.186-1.186h-2.814v-2.774a9.333 9.333 0 008-9.226z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcMic);
export default __webpack_public_path__ + "static/media/icon_ic_mic.bb8175f146533b9fe8f9995ddaf4f4f9.svg";
export { ForwardRef as ReactComponent };